import React, { useEffect, useState } from "react";
import { useNavigate, Navigate } from 'react-router-dom';
import { baseUrl } from "../shared";
import '../pages/App.css';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import OutlinedInput from '@mui/material/OutlinedInput';
import IconButton from '@mui/material/IconButton';

export function ResetUserPassword() {
  const [changed, setChanged] = useState(false);
  var [userEdit, setUserEdit] = useState({});
  var [modUser, setModUser] = useState({});
  var [userList, setUserList] = useState([]);
  const [usersLoaded, setusersLoaded] = useState(false);
  const [userSelected, setUserSelected] = useState(false);
  const navigate = useNavigate();
  const [updateUser] = useState(true);
  const [open, setOpen] = React.useState(false);
  const [responseOpen, setResponseOpen] = React.useState(false);
  const [message, setMessage] = useState('');

  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => { event.preventDefault(); };

  const handleClose = () => {
    <Navigate to={'/admin/'} />;
    { navigate(0); }
  };
  const cancelResetUserPassword = () => {
    <Navigate to={'/admin/'} />;
    { navigate(0); }
  };

  useEffect(() => {
    if (usersLoaded === false) {
      const url = baseUrl + 'user/list/';
      fetch(url, {
        method: 'GET',
        headers: {
          'username': localStorage.getItem('username'),
          'bToken': localStorage.getItem('bToken'),
        },
      })
        .then((res) => res.json())
        .then((json) => {
          setUserList(json);
          setusersLoaded(true);
        })
        .catch((err) => console.log(err.message));
    }
  });

  async function userPasswordReset(e) {
    e.preventDefault();
    const url = baseUrl + 'user/resetPassword';
    await fetch(url, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'username': localStorage.getItem('username'),
        'bToken': localStorage.getItem('bToken'),
      },
      body: ("json", JSON.stringify({ "selUserId": modUser.id, "password": modUser.password })),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          setMessage(data.message);
          setOpen(true);
        } else if (data.status === 401) {
          setMessage(data.message);
          setResponseOpen(true);
        }
      })
      .catch((err) => {
        setMessage(err.message);
        setOpen(true);
      });
  }

  function userDetails(e) {
    const url = baseUrl + 'user/details';
    fetch(url, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'username': localStorage.getItem('username'),
        'bToken': localStorage.getItem('bToken'),
      },
      body: ("json", JSON.stringify({ "selUserId": e })),
    })
      .then((response) => {
        if (!response.ok) throw new Error('something went wrong');
        return response.json();
      })
      .then((data) => {
        setUserEdit(data[0]);
        setModUser(data[0]);
      });
  }

  if (!(updateUser && localStorage.getItem('canAdmin') === '1')) return null;

  return (
    <Card sx={{ p: { xs: 2.5, md: 3.5 }, maxWidth: 480, mx: 'auto' }}>
      <React.Fragment>
        <Dialog open={open} onClose={handleClose}>
          <DialogTitle />
          <DialogContent>
            <DialogContentText>{message}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Ok</Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
      <React.Fragment>
        <Dialog open={responseOpen} onClose={cancelResetUserPassword}>
          <DialogTitle />
          <DialogContent>
            <DialogContentText>{message}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={cancelResetUserPassword}>Ok</Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>

      <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>Reset User Password</Typography>

      <FormControl margin="dense" fullWidth>
        <InputLabel id="usernameTitleLabel">Username</InputLabel>
        <Select
          labelId="usernameTitleLabel"
          label="Username"
          value={modUser.id ?? ''}
          onChange={(e) => {
            setUserSelected(true);
            userDetails(e.target.value);
          }}
        >
          <MenuItem value="" disabled>Select Username to Modify</MenuItem>
          {userList.map((u) => (
            <MenuItem value={u.id} key={u.id}>{u.username}</MenuItem>
          ))}
        </Select>
      </FormControl>

      {userSelected ? (
        <Box sx={{ mt: 1 }}>
          <FormControl fullWidth margin="dense" variant="outlined">
            <InputLabel htmlFor="outlined-adornment-password">New Password</InputLabel>
            <OutlinedInput
              id="outlined-adornment-password"
              type={showPassword ? 'text' : 'password'}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword} edge="end">
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
              onChange={(e) => { setChanged(true); setModUser({ ...modUser, password: e.target.value }); }}
              label="New Password"
            />
          </FormControl>
        </Box>
      ) : null}

      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
        <Button variant="outlined" color="inherit" sx={{ color: 'var(--muted)', borderColor: 'var(--border-strong)' }} onClick={cancelResetUserPassword}>Cancel</Button>
        <Button variant="contained" disabled={!changed} onClick={userPasswordReset}>Reset Password</Button>
      </Box>
    </Card>
  );
}

export default ResetUserPassword;
